import { render } from "./QuemSomos.vue?vue&type=template&id=45c236b9&scoped=true&lang=pug"
import script from "./QuemSomos.vue?vue&type=script&setup=true&lang=js"
export * from "./QuemSomos.vue?vue&type=script&setup=true&lang=js"

import "./QuemSomos.vue?vue&type=style&index=0&id=45c236b9&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45c236b9"]])

export default __exports__